import { render, staticRenderFns } from "./MessageDetailDeleteConfirm.vue?vue&type=template&id=52217b44&scoped=true"
import script from "./MessageDetailDeleteConfirm.vue?vue&type=script&lang=ts"
export * from "./MessageDetailDeleteConfirm.vue?vue&type=script&lang=ts"
import style0 from "./MessageDetailDeleteConfirm.vue?vue&type=style&index=0&id=52217b44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52217b44",
  null
  
)

export default component.exports